export default __webpack_public_path__ + "static/media/client-devices.053f808d.svg";